import React from 'react';
import PropTypes from 'prop-types';

import Button from '../../../../../../../../components/Button';

import FormFields from './components/FormFields';

const Form = (props) => {
  const { values, setFieldValue, onSubmit, onModalClose, errors } = props;

  return (
    <form className="change-cashback-rate">
      <FormFields values={values} onChange={setFieldValue} errors={errors} />
      <div className="modal-actions">
        <Button
          className="modal-save"
          onClick={onSubmit}
          children="Save Changes"
          type="submit"
        />
        <Button
          className="modal-close"
          onClick={onModalClose}
          children="Cancel"
        />
      </div>
    </form>
  );
};

export default Form;

Form.propTypes = {
  values: PropTypes.shape().isRequired,
  onSubmit: PropTypes.func.isRequired,
  onModalClose: PropTypes.func.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  errors: PropTypes.shape(),
};

Form.defaultProps = {
  errors: {},
};
